import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20geometric%20landscape%20with%20flowing%20golden%20amber%20lines%2C%20minimalist%20modern%20design%2C%20soft%20gradient%20from%20warm%20cream%20to%20deep%20terracotta%2C%20smooth%20flowing%20shapes%20suggesting%20stability%20and%20longevity%2C%20clean%20aesthetic%2C%20no%20text%2C%20abstract%20art%20style%2C%20professional%20atmosphere&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="久久久久持久稳定体验"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-4 md:mb-6 tracking-wide">
          久久久久
          <span className="block text-xl md:text-2xl font-normal mt-3 md:mt-4 text-background-200">
            持久稳定，经久不衰
          </span>
        </h1>
        <p className="text-sm md:text-base text-background-300 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          久久久久，专注持久稳定的极致体验。无论是品质保障、长效服务还是耐久性能，
          久久久久为您提供经久不衰的可靠选择，让每一次使用都持续满足您的需求。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/quality"
            className="px-8 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            探索品质保障
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border border-background-300 text-background-100 font-medium text-sm rounded-md hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}